/*
 * Print and "Download PDF" on a recipe page.
 *
 * The PDF is laid out here, in the browser, from what the page shows at the moment of the click, so
 * it carries the machine, tray count and units the reader has chosen. jsPDF is loaded on first
 * click rather than on every page view.
 */
(function () {
  var JSPDF_URL = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
  var ORANGE = [232, 97, 29];
  var INK = [34, 34, 34];
  var GREY = [110, 110, 110];
  var RULE = [205, 205, 205];
  var PAGE_W = 210;
  var PAGE_H = 297;
  var M = 15;
  var BOTTOM = PAGE_H - M - 6;
  var ING_W = 62;
  var GAP = 9;
  var STEP_X = M + ING_W + GAP;
  var STEP_W = PAGE_W - M - STEP_X;

  var FRACTIONS = { '⅓': '1/3', '⅔': '2/3', '⅛': '1/8', '⅜': '3/8', '⅝': '5/8', '⅞': '7/8', '⅕': '1/5' };

  function clean(text) {
    return String(text || '')
      .replace(/[⅓⅔⅛⅜⅝⅞⅕]/g, function (c) { return FRACTIONS[c]; })
      .replace(/[    ]/g, ' ')
      .replace(/[‐‑−]/g, '-')
      .replace(/[^ -ÿ–—‘’“”•…€™]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (window.jspdf) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = function () { reject(new Error('Could not load the PDF library')); };
      document.head.appendChild(s);
    });
  }

  function toImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('image')); };
      img.src = src;
    });
  }

  function logoPng(button) {
    var candidates = ['/cdn/shop/files/bfd_logo.svg', button.getAttribute('data-logo')].filter(Boolean);
    function attempt(i) {
      if (i >= candidates.length) return Promise.resolve(null);
      return fetch(candidates[i])
        .then(function (r) { if (!r.ok) throw new Error('logo'); return r.text(); })
        .then(function (svg) { return toImage('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg)); })
        .then(function (img) {
          var w = img.naturalWidth || 174;
          var h = img.naturalHeight || 65;
          var c = document.createElement('canvas');
          c.width = w * 4;
          c.height = h * 4;
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          return { data: c.toDataURL('image/png'), ratio: w / h };
        })
        .catch(function () { return attempt(i + 1); });
    }
    return attempt(0);
  }

  function heroJpeg(ratio) {
    var el = document.querySelector('.image-banner img');
    var src = el && (el.currentSrc || el.src);
    if (!src) return Promise.resolve(null);
    return fetch(src)
      .then(function (r) { if (!r.ok) throw new Error('hero'); return r.blob(); })
      .then(function (blob) { return toImage(URL.createObjectURL(blob)); })
      .then(function (img) {
        var sw = img.naturalWidth;
        var sh = img.naturalHeight;
        var cw = sw;
        var ch = sw / ratio;
        if (ch > sh) { ch = sh; cw = sh * ratio; }
        var c = document.createElement('canvas');
        c.width = Math.min(1600, Math.round(cw));
        c.height = Math.round(c.width / ratio);
        c.getContext('2d').drawImage(img, (sw - cw) / 2, (sh - ch) / 2, cw, ch, 0, 0, c.width, c.height);
        return c.toDataURL('image/jpeg', 0.85);
      })
      .catch(function () { return null; });
  }

  function text(el) { return clean(el && el.textContent); }

  function readPage() {
    var facts = [];
    document.querySelectorAll('.recipe-info li').forEach(function (li) {
      var k = li.querySelector('.meta-title');
      var v = li.querySelector('.meta-text');
      if (k && v) facts.push([text(k).toUpperCase(), text(v)]);
    });
    var machine = document.querySelector('.recipe-info .machine-recommendation strong');
    if (machine) facts.unshift(['MACHINE', text(machine)]);

    var chosen = document.querySelector('.uxf-tray__machine[aria-checked="true"] .uxf-tray__machine-name');
    var note = document.querySelector('.uxf-tray__note');
    var scaled = '';
    if (chosen) scaled = 'Scaled for the ' + text(chosen) + (note && note.textContent ? '. ' + text(note) : '');

    function walk(root, kind) {
      var out = [];
      if (!root) return out;
      Array.prototype.forEach.call(root.children, function (el) {
        var tag = el.tagName;
        if (el.matches('.section-title') || el.matches('.uxf-tray') || el.querySelector('.uxf-tray')) return;
        if (/^H[2-6]$/.test(tag)) out.push({ t: 'h', s: text(el) });
        else if (tag === 'UL' || tag === 'OL') {
          Array.prototype.forEach.call(el.children, function (li) {
            var s = text(li);
            if (s) out.push({ t: kind, s: s });
          });
        } else if (tag === 'P' && text(el)) out.push({ t: 'p', s: text(el) });
      });
      return out;
    }

    return {
      title: text(document.querySelector('h1')),
      category: text(document.querySelector('.article__tags')),
      excerpt: text(document.querySelector('.uxf-recipe-excerpt')),
      facts: facts,
      scaled: scaled,
      ingredients: walk(document.querySelector('.recipe-details .ingredients'), 'i'),
      steps: walk(document.querySelector('.recipe-details .instructions'), 's'),
      version: text(document.querySelector('.uxf-app-version')),
      url: location.hostname + location.pathname
    };
  }

  function build(jsPDF, data, logo, hero) {
    var doc = new jsPDF({ unit: 'mm', format: 'a4' });
    var LH = 0.3528 * 1.38;

    function set(size, style, color) {
      doc.setFont('helvetica', style || 'normal');
      doc.setFontSize(size);
      doc.setTextColor.apply(doc, color || INK);
    }
    function lines(str, size, style, width) {
      set(size, style);
      return doc.splitTextToSize(str, width);
    }

    function header(first) {
      if (logo) {
        var h = first ? 17 : 9;
        doc.addImage(logo.data, 'PNG', M, M - 3, h * logo.ratio, h);
      } else {
        set(first ? 16 : 10, 'bold', ORANGE);
        doc.text('BenchFoods Dehydrators', M, M + 4);
      }
      if (!first) {
        set(8.5, 'normal', GREY);
        doc.text(data.title, PAGE_W - M, M + 3, { align: 'right', maxWidth: 110 });
      }
      var y = M + (first ? 17 : 8);
      doc.setDrawColor.apply(doc, ORANGE);
      doc.setLineWidth(first ? 0.9 : 0.5);
      doc.line(M, y, PAGE_W - M, y);
      return y + (first ? 8 : 7);
    }

    var y = header(true);

    if (data.category) {
      set(8.5, 'bold', ORANGE);
      doc.text(data.category.toUpperCase(), M, y);
      y += 6;
    }
    set(23, 'bold');
    var tl = doc.splitTextToSize(data.title, PAGE_W - 2 * M);
    doc.text(tl, M, y + 3);
    y += tl.length * 10 + 1;
    if (data.excerpt) {
      var el = lines(data.excerpt, 10.5, 'italic', PAGE_W - 2 * M);
      set(10.5, 'italic', GREY);
      doc.text(el, M, y + 1);
      y += el.length * 10.5 * LH + 3;
    }

    if (hero) {
      var hh = (PAGE_W - 2 * M) / 3.6;
      doc.addImage(hero, 'JPEG', M, y, PAGE_W - 2 * M, hh);
      y += hh + 5;
    }

    if (data.facts.length) {
      var cell = (PAGE_W - 2 * M) / data.facts.length;
      doc.setFillColor(248, 243, 238);
      doc.roundedRect(M, y, PAGE_W - 2 * M, 14, 1.5, 1.5, 'F');
      data.facts.forEach(function (f, i) {
        var x = M + i * cell + cell / 2;
        set(7, 'bold', ORANGE);
        doc.text(f[0], x, y + 5.2, { align: 'center' });
        set(9.5, 'bold');
        doc.text(doc.splitTextToSize(f[1], cell - 4).slice(0, 2), x, y + 10, { align: 'center' });
      });
      y += 19;
    }
    if (data.scaled) {
      var sl = lines(data.scaled, 9, 'italic', PAGE_W - 2 * M);
      set(9, 'italic', GREY);
      doc.text(sl, M, y);
      y += sl.length * 9 * LH + 3;
    }
    y += 2;

    function colBlocks(items, width, kind) {
      var blocks = [];
      var n = 0;
      items.forEach(function (it) {
        if (it.t === 'h') {
          var hl = lines(it.s, 10.5, 'bold', width);
          blocks.push({ h: hl.length * 10.5 * LH + 5, draw: function (x, yy) {
            set(10.5, 'bold', ORANGE);
            doc.text(hl, x, yy + 5);
          } });
        } else if (it.t === 'p') {
          var pl = lines(it.s, 8.5, 'italic', width);
          blocks.push({ h: pl.length * 8.5 * LH + 3, draw: function (x, yy) {
            set(8.5, 'italic', GREY);
            doc.text(pl, x, yy + 3);
          } });
        } else if (kind === 'i') {
          var il = lines(it.s, 10, 'normal', width - 5);
          blocks.push({ h: il.length * 10 * LH + 3.4, draw: function (x, yy) {
            set(10, 'normal', ORANGE);
            doc.text('•', x, yy + 3.6);
            set(10, 'normal');
            doc.text(il, x + 4.5, yy + 3.6);
            var bottom = yy + il.length * 10 * LH + 2.2;
            doc.setDrawColor.apply(doc, RULE);
            doc.setLineWidth(0.2);
            doc.setLineDashPattern([0.8, 0.8], 0);
            doc.line(x, bottom, x + width, bottom);
            doc.setLineDashPattern([], 0);
          } });
        } else {
          n += 1;
          var num = n;
          var sl2 = lines(it.s, 10.5, 'normal', width - 11);
          blocks.push({ h: Math.max(sl2.length * 10.5 * LH, 7) + 4.5, draw: function (x, yy) {
            doc.setFillColor.apply(doc, ORANGE);
            doc.circle(x + 3.4, yy + 3.4, 3.4, 'F');
            set(9.5, 'bold', [255, 255, 255]);
            doc.text(String(num), x + 3.4, yy + 4.7, { align: 'center' });
            set(10.5, 'normal');
            doc.text(sl2, x + 11, yy + 4);
          } });
        }
      });
      return blocks;
    }

    var cols = [
      { x: M, w: ING_W, title: 'Ingredients', blocks: colBlocks(data.ingredients, ING_W, 'i') },
      { x: STEP_X, w: STEP_W, title: 'Method', blocks: colBlocks(data.steps, STEP_W, 's') }
    ];

    var top = y;
    var pageNo = 1;
    var guard = 0;
    while (cols.some(function (c) { return c.blocks.length; }) && guard++ < 40) {
      cols.forEach(function (c) {
        if (!c.blocks.length) return;
        var cy = top;
        if (pageNo === 1) {
          set(13, 'bold', ORANGE);
          doc.text(c.title, c.x, cy + 4);
          doc.setDrawColor.apply(doc, ORANGE);
          doc.setLineWidth(0.4);
          doc.line(c.x, cy + 6.5, c.x + c.w, cy + 6.5);
          cy += 10;
        }
        var first = cy;
        while (c.blocks.length && (cy + c.blocks[0].h <= BOTTOM || cy === first)) {
          var b = c.blocks.shift();
          b.draw(c.x, cy);
          cy += b.h;
        }
      });
      if (cols.some(function (c) { return c.blocks.length; })) {
        doc.addPage();
        pageNo += 1;
        top = header(false);
      }
    }

    var total = doc.getNumberOfPages();
    for (var p = 1; p <= total; p++) {
      doc.setPage(p);
      doc.setDrawColor.apply(doc, RULE);
      doc.setLineWidth(0.2);
      doc.line(M, PAGE_H - M - 2, PAGE_W - M, PAGE_H - M - 2);
      set(8, 'normal', GREY);
      doc.text(data.url, M, PAGE_H - M + 2, { maxWidth: 100 });
      doc.text((data.version ? data.version + '  |  ' : '') + 'Page ' + p + ' of ' + total, PAGE_W - M, PAGE_H - M + 2, { align: 'right' });
    }
    return doc;
  }

  function slug(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'recipe';
  }

  function makeDoc(pdfButton) {
    var data = readPage();
    return Promise.all([loadScript(JSPDF_URL), logoPng(pdfButton), heroJpeg(3.6)]).then(function (r) {
      return { doc: build(window.jspdf.jsPDF, data, r[1], r[2]), name: slug(data.title) + '.pdf' };
    });
  }

  /* Print is the PDF, sent to the printer, so the two cannot differ. */
  function printBlob(blob) {
    var url = URL.createObjectURL(blob);
    var frame = document.createElement('iframe');
    frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
    frame.onload = function () {
      try {
        frame.contentWindow.focus();
        frame.contentWindow.print();
      } catch (e) {
        window.open(url, '_blank');
      }
    };
    frame.src = url;
    document.body.appendChild(frame);
    setTimeout(function () { frame.remove(); URL.revokeObjectURL(url); }, 120000);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-recipe-pdf], [data-recipe-print]');
    if (!button || button.disabled) return;
    var printing = button.hasAttribute('data-recipe-print');
    var pdfButton = document.querySelector('[data-recipe-pdf]') || button;

    var label = button.lastChild;
    var original = label.textContent;
    button.disabled = true;
    label.textContent = ' Preparing…';

    makeDoc(pdfButton)
      .then(function (made) {
        if (printing) printBlob(made.doc.output('blob'));
        else made.doc.save(made.name);
      })
      .catch(function () {
        window.print();
      })
      .then(function () {
        button.disabled = false;
        label.textContent = original;
      });
  });
})();
